import Menu from './Menu'
import MenuMobile from'./MenuMobile'
import MenuCategoriesHome from'./MenuCategoriesHome'
import MenuWishlist from'./MenuWishlist.vue'
import MenuMyAccount from'./MenuMyAccount.vue'
import LogoMobileHeaderTop from'./LogoMobileHeaderTop.vue'
import SearchMobileHeaderTop from'./SearchMobileHeaderTop.vue'
import HeaderApp from'./HeaderApp.vue'

export default {
    'menu-app': Menu,
    'menu-mobile': MenuMobile,
    'menu-categories-home': MenuCategoriesHome,
    'menu-wishlist': MenuWishlist,
    'menu-my-account': MenuMyAccount,
    'logo-mobile-header-top': LogoMobileHeaderTop,
    'search-mobile-header-top': SearchMobileHeaderTop,
    'header-app': HeaderApp
}
